var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.item && _vm.item.footerDescription)?_c('div',{staticClass:"polycarbonate"},[_c('div',{staticClass:"polycarbonate__wrapper"},[_c('h2',[_vm._v(_vm._s(_vm.item.footerTitle))]),_c('div',{staticClass:"polycarbonate__wrapper-content",domProps:{"innerHTML":_vm._s(_vm.item.footerDescription)}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }